var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-view-layout"},[_c('div',{staticClass:"title__container"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }